<template>
  <div>
    <PageTitle title="Shop to Shop Transfer Details" :backBtn="true" />

    <v-row class="mx-2">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="lighten-12">
              <v-card-title class="py-0">
                <v-icon color="blue" small>mdi-sale</v-icon
                ><span class="ml-3"> Transfer Details</span>
              </v-card-title>
              <v-container fluid class="container saledetailscard">
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                    <v-row class="pt-0">
                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                        lg="4"
                        class="pr-5pt-1.5 pb-1 reference_number"
                      >
                        <v-icon>mdi-sale</v-icon>
                        {{
                          StockTransfer.reference_number
                            ? StockTransfer.reference_number
                            : '----'
                        }}
                      </v-col>

                      <v-col cols="12" sm="12" md="4" lg="4">
                        <span class="statustext pr-5">Status</span>
                        <v-chip
                          label
                          text-color="white"
                          style="
                            font-variant-caps: all-small-caps;
                            font-weight: bold;
                          "
                          :color="getPurchaseOrderStatusColor('Completed')"
                          dark
                        >
                          Completed
                        </v-chip>
                      </v-col>

                      <v-col cols="12" sm="12" md="4" lg="4">
                        <span class="statustext pr-5">Status Note</span>

                        {{
                          StockTransfer.statusNote
                            ? StockTransfer.statusNote
                            : '----'
                        }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                        lg="4"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable"> Transfer Date </v-row>
                        <v-row>
                          {{ StockTransfer.date | formatDate }}
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="1"
                        lg="1"
                        class="shoptext pr-5 pt-0 mt-7"
                      >
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="3"
                        lg="3"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable"> From Shop </v-row>
                        <v-row>
                          {{
                            StockTransfer.fromShop.name
                              ? StockTransfer.fromShop.name
                              : '----'
                          }}
                        </v-row>
                      </v-col>

                      <v-col
                        cols="1"
                        sm="12"
                        md="1"
                        lg="1"
                        class="shoptext pr-5 pt-0 mt-7"
                      >
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="3"
                        lg="3"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable">Transfer To Shop </v-row>
                        <v-row>
                          <v-icon small>mdi-calendar</v-icon>
                          {{
                            StockTransfer.toShop.name
                              ? StockTransfer.toShop.name
                              : '----'
                          }}

                          <!-- <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                large
                                color="primary darken-2"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1 white ml-2"
                                @click="changeShop()"
                              >
                                mdi-pencil
                              </v-icon>
                            </template>
                          </v-menu> -->

                          <v-row v-if="isTrue">
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              class="text-right"
                            >
                              <ValidationProvider name="Shop" rules="required">
                                <v-autocomplete
                                  outlined
                                  hide-details="auto"
                                  v-model="StockTransfer.to_shop_id"
                                  item-text="name"
                                  item-value="id"
                                  :items="shops"
                                  :search-input.sync="searchShop"
                                  :loading="shopLoading"
                                  :error-messages="errors"
                                  label="Shop"
                                  required
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              class="text-left"
                              v-if="isTrue"
                            >
                              <v-btn
                                color="green"
                                x-small
                                dark
                                :disabled="isDisabledShop"
                                @click="openConfirmation()"
                              >
                                <v-icon link>done</v-icon>
                              </v-btn>
                              <v-btn
                                color="secondary"
                                x-small
                                dark
                                class="ma-1"
                                @click="cancelShopUpdate()"
                              >
                                <v-icon
                                  depressed
                                  small
                                  link
                                  @click="cancelShopUpdate()"
                                  >clear</v-icon
                                >
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
        <v-card class="lighten-12 container pa-0">
          <v-card-title class="d-flex justify-space-between v-card__title py-0"
            >Transfered Product details
            <!-- <v-btn small class="text-white btn_gray w-100" v-print="printQr"
              >Print <v-icon right dark> mdi-printer </v-icon></v-btn
              > -->
          </v-card-title>
          <v-container fluid class="container saledetailscard">
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-data-table
                  class="std-100 ma-0 pa-0"
                  items-per-page="15"
                  :fixed-header="true"
                  :headers="StockTransferHeaders"
                  :items="selectedProductsToTransfer"
                  hide-default-footer
                  dense
                  expand
                >
                  <template v-slot:item.data-table-expand="{ item }">
                  </template>
                  <template v-slot:expanded-item="{ headers, item: childItem }">
                    <td :colspan="headers.length">
                      <v-card class="pa-0">
                        <v-data-table
                          dense
                          hide-default-footer
                          :items="unitDetails"
                          :headers="TransferItemUnitHeaders"
                          class="sub-table pb-1 mx-0"
                        >
                          <v-progress-linear
                            v-show="progressBar"
                            slot="progress"
                            color="blue"
                            indeterminate
                          ></v-progress-linear>
                        </v-data-table>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card>
            <v-card-title>Note</v-card-title>

            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12"
                  ><v-chip class="pa-0" label>
                    {{ StockTransfer.remarks ? StockTransfer.remarks : "----" }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChangeStatus from '@/components/shared/ChangeStatus';
import FileUpload from '@/components/base/FileUpload';
import VueDocPreview from 'vue-doc-preview';
import 'jspdf-autotable';
import { StockTransferModel } from '@/models/ShopStockTransferModel';

export default {
  data: () => ({
    PurchaseOrder: [],
    shopId: '',
    shopName: '',
    expanded: [],
    isTrue: false,
    isDisabledShop: false,
    shops: [],
    changeStatusVisible: false,
    visibleChangeStatusModal: false,
    singleExpand: true,
    isChange: false,
    isTrue: false,
    transferStatuses: [
      { requiredNote: false, status: 'Completed' },
      { requiredNote: false, status: 'Pending' },
      { requiredNote: false, status: 'Canceled' },
    ],
    StatusReasonErrorMessages: [],
    unitDetails: [],
    StockTransferStatus: ['Completed', 'Canceled', 'Pending'],
    selectedProductsToTransfer: [],
    StockTransfer: new StockTransferModel(),
    heading: 'Sample PDF Generator',
    moreText: [
      'This is another few sentences of text to look at it.',
      'Just testing the paragraphs to see how they format.',
      'jsPDF likes arrays for sentences.',
      'Do paragraphs wrap properly?',
      'Yes, they do!',
      'What does it look like?',
      'Not bad at all.',
    ],

    selectedProductsItems: [],

    StockTransferHeaders: [
      { text: 'Product', value: 'product.name', sortable: false },
      { text: 'Batch', value: 'batch.batch', sortable: false },
      { text: 'Quantity', value: 'quantity', sortable: false },
      { text: 'Unit', value: 'unit.name', sortable: false, align: 'center' },
    ],
    TransferItemUnitHeaders: [
      { text: 'Unit', value: 'name', sortable: false },
      { text: 'Tranferable Percentage', value: 'percentage', sortable: false },
      { text: 'Quantity', value: 'quantity', sortable: false },
    ],
  }),
  methods: {
    changeShop() {
      this.isTrue = true;
    },
    cancelShopUpdate() {
      this.isTrue = false;
    },
    getStockTransfer() {
      this.Loading = true;
      this.$store
        .dispatch('product/GetShopTranferDetails', this.$route.params.id)
        .then((res) => {
          this.MapStoreTranfer(res);
        })
        .catch((err) => {
          this.warehouseLoading = false;
          this.messages = err.data.name;
        });
    },

    // shop update button function
    openConfirmation() {
      confirmation.dialog = true;
      this.$confirm('Are you sure with the update ').then((res) => {
        if (res) {
          this.submit();
        }
      });
    },
    // Shop Update Function
    async submit() {
      this.StockTransfer.items = this.selectedProductsToTransfer;
      let Credentials = new Object();
      Credentials.date = this.StockTransfer.date;
      Credentials.remarks = this.StockTransfer.remarks;
      Credentials.from_ware_house_id = this.StockTransfer.from_ware_house_id;

      Credentials.to_shop_id = this.StockTransfer.to_shop_id;
      Credentials.items = [];
      Credentials.id = this.$route.params.id;
      this.$store
        // .dispatch("product/TranferProductToShopFromWarehouseEdit", Credentials)
        .then((res) => {
          this.$toast.success('Product Transfered Successfully');
          this.$router.push('/stock-transfer');
        })
        .catch((err) => {});
    },

    ExpandItem(event) {
      this.progressBar = true;
      this.unitDetails = event.transferUnit;
      this.expanded = [];
      this.progressBar = false;
      this.expanded.push(event);
    },

    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;

        default:
          break;
      }
    },
    // get shops from shop DB
    getShopsByQuery(query = '') {
      this.shopLoading = true;
      this.$store
        .dispatch('warehouse/GetShops', { query: query })
        .then((res) => {
          this.shops = res;
          this.shopLoading = false;
        })
        .catch((err) => {
          this.shopLoading = false;
          this.messages = err.data.name;
        });
    },

    MapStoreTranfer(stockTransferDetails) {
      let count = 1;
      var StockTransfer = new Object();
      StockTransfer.date = stockTransferDetails.date;
      StockTransfer.reference_number = stockTransferDetails.reference_number;
      StockTransfer.status = stockTransferDetails.status;
      StockTransfer.statusNote = stockTransferDetails.status_note;
      StockTransfer.fromShop = stockTransferDetails.fromShop;
      // StockTransfer.fromshop.name = stockTransferDetails.fromshop.name;
      StockTransfer.toShop = stockTransferDetails.toShop;
      var a = stockTransferDetails.shopTransferItems.map((p) => {
        let item = new Object();
        item.product = p.product;
        item.batch = p.batch;
        item.quantity = p.quantity;
        item.unit = p.unit;
        item.id = count;
        let val = this.selectedProductsToTransfer.filter(
          (i) => item.id == i.id,
        );
        if (val.length == 0) {
          this.selectedProductsToTransfer.push(item);
        }

        count++;
        return item;
      });
      this.StockTransfer = StockTransfer;
    },

    async updatetoShop() {
      this.isLoading = true;
      let payload = {
        id: this.toShopId,
        name: this.toShopName,
      };
      this.isDisabledChequefor = true;
      this.$store
        .dispatch('chequeManagement/changeChequeFor', payload) //dispatching API for toShop edit
        .then((res) => {
          this.isLoading = false;
          this.isDisabledChequefor = false;
          this.$toast.success('Shop name successfully updated');
          this.getCheque(this.chequeId);
          this.showChequefor = false;
          this.paymentable_id = '';
          this.paymentable_type = '';
        })
        .catch((err) => {
          this.isDisabledChequefor = false;
          this.$toast.error('Failed to update shop name');
          this.isLoading = false;
          this.showChequefor = true;
        });
    },
  },
  created() {
    this.getStockTransfer();
    this.getShopsByQuery();
  },
  watch: {
    searchShop(value) {
      if (!value) {
        this.getShopsByQuery('');
      }
      this.getShopsByQuery(value);
    },
  },
  components: {
    FileUpload,
    VueDocPreview,
    ChangeStatus,
  },
  computed: {
    printQr() {},
    ...mapState(['productpagesize']),
  },
};
</script>

<style>
.std-100 {
  font-weight: bold;
}
.std-101 {
  font-weight: 900;
}

.rowspce {
  margin-bottom: -100px;
}

.cntclr {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}

.container1 {
  margin-right: 24px;
  margin-left: 20px;
}
.purchaseDetail {
  font-weight: bold;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: left;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>
